
// SpaceProject


export enum ProjectsTreeSortType {
    MANUAL_OLD      = 'default',    // deprecated
    ALPHABETICAL    = 'alphabetical',
    MANUAL          = 'manual',
}

export type SpacePreferences = {

    projectsSorting?            : ProjectsTreeSortType
    projectsColorize?           : boolean

    sortedMap?                  : any

}
